import React from "react";
import { useAppState } from "../../Redux/ReduxHooks";
import { CreditCardForm } from "./CreditCardForm";
import { OptionalUI } from "../Booking/OptionalParts/OptionalUI";
import { BookingFlowTriggerSource } from "../UILogicControl/UILogicControlEntities";

/** Possibly renders the credit/debit card input fields inline in the booking form. */
export const MaybeCreditCardForm: React.FC = () => {

    const featureEnabled = useAppState(OptionalUI.GuestCreditCard);
    const isInlineCreditCardSelected = useAppState(i => i.booking.PaymentOption?.Id === "CreditOrDebit");
    const isCreditCardSelectedForPhoneToCnp = useAppState(state => state.PhoneToCnp.PaymentOption?.Id === "CreditOrDebit");
    const bookingTrigger = useAppState(state => state.uiLogicControl.BookingFlowTrigger);

    if (!featureEnabled) return null;

    // Hosted fields cannot be initialised until the DOM nodes are created. We need to initialise this earlier than dropdown selection in order to prevent iOS page refresh issue. Hence, creating the DOM early, but keep it hidden until the Credit/Debit option is selectedd from the dropdown.
    const isVisible = bookingTrigger === BookingFlowTriggerSource.TrackingSms ? isCreditCardSelectedForPhoneToCnp : isInlineCreditCardSelected;

    return (
        <div style={{ display: isVisible ? "block" : "none" }}>
            <CreditCardForm />
        </div>
    );
}